<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol">
      <table class="c-indicator c-indicator-w-100">
        <TableHeadAddDZ :document-conf="documentConf" />
        <template v-if="docs">
          <tbody>
             <TableRowAddDZ
            v-for="(doc, docIndex) in docs"
            :key="childIndex + '.' + docIndex"
            :index="index"
            :doc-index="docIndex"
            :doc="doc"
            :docsType="docs"
            :document-conf="documentConf"
            :document-history="documentHistory"
          />
          </tbody>
        </template>
        <template v-for="(child, childIndex) in childs">
          <tbody :key="childIndex">
            <tr class="back-jur" :key="'tr' + childIndex">
              <td>{{ index }}.{{ childIndex + (docs && docs.length)?(docs.length+1):1 }}</td>
              <td>
                <a
                  v-if="child.SECTION_HELP"
                  class="icon-help-blue"
                  style="display: inline-block;position: initial; margin-left:0; background-position: left center"
                  v-tooltip="{
                    content: child.SECTION_HELP,
                    classes: 'message'
                  }"
                  >&nbsp;
                </a>
              </td>
              <td style="min-width:50px;">
                <i
                  class="i-edit centerIcon"
                  @click="
                    $parent.showEditTableDialog(
                      child.RECORD_MODEL_ID,
                      child.SECTION_NAME
                    )
                  "
                  v-if="child.BLOCK_IS_EDIT_NAME && $parent.addBlocks"
                />
                <i
                  class="i-delete centerIcon"
                  @click="
                    $parent.deleteField(
                      child.RECORD_MODEL_ID,
                      child.SECTION_NAME
                    )
                  "
                  v-if="child.BLOCK_IS_EDIT_NAME && $parent.addBlocks"
                />
              </td>
              <td :colspan="documentConf.IS_RFRP_PROGRAM ? 16 : 14">
                <b>{{ child.SECTION_NAME }}</b>
              </td>
            </tr>
            <TableRowAddDZ
              v-for="(doc, docIndex) in child.TYPE_LIST_ID"
              :key="childIndex + '.' + docIndex"
              :index="index + '.' + childIndex + 1"
              :doc-index="docIndex"
              :doc="doc"
              :docsType="child.TYPE_LIST_ID"
              :document-conf="documentConf"
              :document-history="documentHistory"
            />
          </tbody>

          <template v-for="(subchild, subChildIndex) in child.CHILD">
            <tbody :key="childIndex + '.' + subChildIndex">
              <tr
                class="back-jur"
                :key="'tr' + childIndex + '.' + subChildIndex"
              >
                <td>
                  {{ index }}.{{
                    childIndex +
                    (docs && docs.length)?(docs.length+1):1 +
                      (child.TYPE_LIST_ID ? child.TYPE_LIST_ID.length : 0)
                  }}.{{ subChildIndex + 1 }}
                </td>
                <td style="min-width:30px;">
                  <a
                    v-if="subchild.SECTION_HELP"
                    class="icon-help-blue icon-help-blue-table-dz"
                    style="display: inline-block;position: initial; margin-left:0;background-position: left center"
                    v-tooltip="{
                      content: subchild.SECTION_HELP,
                      classes: 'message'
                    }"
                  >
                    &nbsp;
                  </a>
                </td>
                <td style="min-width:30px;">
                  <i
                    class="i-edit centerIcon"
                    @click="
                      $parent.showEditTableDialog(
                        subchild.RECORD_MODEL_ID,
                        subchild.SECTION_NAME
                      )
                    "
                    v-if="subchild.BLOCK_IS_EDIT_NAME && $parent.addBlocks"
                  />
                  <i
                    class="i-delete centerIcon"
                    @click="
                      $parent.deleteField(
                        subchild.RECORD_MODEL_ID,
                        subchild.SECTION_NAME
                      )
                    "
                    v-if="subchild.BLOCK_IS_DELETE && $parent.addBlocks"
                  />
                </td>
                <td :colspan="documentConf.IS_RFRP_PROGRAM ? 16 : 14">
                  <b>{{ subchild.SECTION_NAME }}</b>
                </td>
              </tr>
              <TableRowAddDZ
                v-for="(doc, docIndex) in subchild.TYPE_LIST_ID"
                :index="
                  index + '.' + (childIndex + (docs && docs.length)?(docs.length+1):1) + '.' + (subChildIndex + 1)
                "
                :key="childIndex + '.' + subChildIndex + '.' + docIndex"
                :doc-index="docIndex"
                :doc="doc"
                :docsType="subchild.TYPE_LIST_ID"
                :document-conf="documentConf"
                :document-history="documentHistory"
              />
            </tbody>

            <!-- блок сравнения БГ -->
            <tbody>
              <tr v-if="subchild.IS_VIEW_BUTTON_COMPARE_BG == 1">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td :colspan="documentConf.IS_RFRP_PROGRAM ? 16 : 14">
                  <button
                    class="tab-but-doc compare"
                    :disabled="keyMapTemp > 0 ? true : false"
                    @click="startCompare(subchild, subchild.BG_COMPARE_FILE_ID)"
                  >
                    Сравнить БГ
                  </button>

                  <div
                    v-if="showStatusCompare[subchild.BG_COMPARE_KEY_ID]"
                    class="area-slider"
                    style="margin-top:10px; width: 173px;"
                  >
                    <div class="progress progress-striped">
                      <div
                        class="progress-bar progress-bar-success"
                        role="progressbar"
                        :aria-valuenow="34"
                        aria-valuemin="0"
                        :aria-valuemax="100"
                        :style="{
                          width:
                            percentCompare[subchild.BG_COMPARE_KEY_ID] + '%'
                        }"
                      >
                        <span class="sr-only"
                          >{{
                            percentCompare[subchild.BG_COMPARE_KEY_ID]
                          }}%</span
                        >
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>

            <template v-for="(subchild2, subChildIndex2) in subchild.CHILD">
              <tbody
                :key="childIndex + '.' + subChildIndex + '.' + subChildIndex2"
              >
                <tr
                  class="back-jur"
                  :key="
                    'tr' +
                      childIndex +
                      '.' +
                      subChildIndex +
                      '.' +
                      subChildIndex2
                  "
                >
                  <td>
                    {{ index }}.{{
                      childIndex +
                        1 +
                        (child.TYPE_LIST_ID ? child.TYPE_LIST_ID.length : 0)
                    }}.{{ subChildIndex + 1 }}.{{ subChildIndex2 + 1 }}
                  </td>
                  <td>
                    <a
                      v-if="subchild2.SECTION_HELP"
                      class="icon-help-blue icon-help-blue-table-dz"
                      style="display: inline-block;position: initial; margin-left:0;background-position: left center"
                      v-tooltip="{
                        content: subchild2.SECTION_HELP,
                        classes: 'message'
                      }"
                      >&nbsp;
                    </a>
                  </td>
                  <td>
                    <i
                      class="i-edit centerIcon"
                      @click="
                        $parent.showEditTableDialog(
                          subchild2.RECORD_MODEL_ID,
                          subchild2.SECTION_NAME
                        )
                      "
                      v-if="subchild2.BLOCK_IS_EDIT_NAME && $parent.addBlocks"
                    />
                    <i
                      class="i-delete centerIcon"
                      @click="
                        $parent.deleteField(
                          subchild2.RECORD_MODEL_ID,
                          subchild2.SECTION_NAME
                        )
                      "
                      v-if="subchild2.BLOCK_IS_EDIT_NAME && $parent.addBlocks"
                    />
                  </td>
                  <td :colspan="documentConf.IS_RFRP_PROGRAM ? 15 : 13">
                    <b>{{ subchild2.SECTION_NAME }}</b>
                  </td>
                </tr>
                <TableRowAddDZ
                  v-for="(doc2, docIndex2) in subchild2.TYPE_LIST_ID"
                  :index="
                    index +
                      '.' +
                      (childIndex + 1) +
                      '.' +
                      (subChildIndex + 1) +
                      '.' +
                      (subChildIndex2 + 1)
                  "
                  :key="
                    childIndex +
                      '.' +
                      subChildIndex +
                      '.' +
                      subChildIndex2 +
                      '.' +
                      docIndex2
                  "
                  :doc-index="docIndex2"
                  :doc="doc2"
                  :docsType="subchild2.TYPE_LIST_ID"
                  :document-conf="documentConf"
                  :document-history="documentHistory"
                />
              </tbody>
            </template>
          </template>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import TableHeadAddDZ from "@/components/project/documents/TableHeadAddDZ";
import TableRowAddDZ from "@/components/project/documents/TableRowAddDZ";
import UploadRowAddDZ from "@/components/project/documents/UploadRowAddDZ";
import { ProjectsService } from "@/common/api.service";
import TableRow from "./TableRow";
import Vue from "vue";

export default {
  components: { TableRow, UploadRowAddDZ, TableRowAddDZ, TableHeadAddDZ },
  props: [
    "docs",
    "documentConf",
    "index",
    "project",
    "childs",
    "documentHistory"
  ],
  name: "MultiDocumentTableAddDZ",
  data() {
    return {
      showStatusCompare: {},
      isBlockButton: false,
      percentCompare: {},
      keyMapTemp: 0
    };
  },
  methods: {
    startCompare(section, bgCompareFileId) {
      this.keyMapTemp = section.BG_COMPARE_KEY_ID;
      Vue.set(this.showStatusCompare, [this.keyMapTemp], true);
      Vue.set(this.percentCompare, [this.keyMapTemp], 1);

      let timerId = setInterval(this.startAnime, 1500);

      ProjectsService.compareBGDocumentDZ(this.$route.params.id, {
        BG_COMPARE_FILE_ID: bgCompareFileId
      }).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        } else {
          this.$parent.updateDocInfo();
          this.$toasted.show(
            "Отчет сверки банковских гарантий получен, идет обновление списка документов...",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
        }

        Vue.set(this.percentCompare, [this.keyMapTemp], 100);
        setTimeout(() => {
          console.log("закрытие ...");
          Vue.set(this.showStatusCompare, [this.keyMapTemp], false);
          this.keyMapTemp = 0;
          clearInterval(timerId);
        }, 2000);
      }, this);

      if (this.percentCompare[this.keyMapTemp] == 100) {
        this.keyMapTemp = 0;
        clearInterval(timerId);
      }
    },

    startAnime() {
      let valTemp = parseInt(this.percentCompare[this.keyMapTemp]);
      if (valTemp <= 95) {
        valTemp++;
        this.percentCompare[this.keyMapTemp] = valTemp;
        Vue.set(this.percentCompare, [this.keyMapTemp], valTemp);
        console.log(valTemp);
      }
    }
  }
};
</script>

<style scoped></style>
